import { ConfirmDialog } from '@/ui'

/** The ways a maker's story ends. None of them can be taken back from the
 *  console, so each is asked first and says so. */
export type EndingKind = 'do_not_contact' | 'invalid_profile' | 'skipped' | 'closed'

const COPY: Record<EndingKind, { title: (maker: string) => string; description: string; confirm: string }> = {
  do_not_contact: {
    title: (maker) => `${maker}을(를) 연락 금지로 끝낼까`,
    description: '이 메이커는 이 캠페인에서 영구히 끝난다. 더는 단계가 올라오지 않고, 되돌리는 화면이 없다.',
    confirm: '연락 금지로 끝내기',
  },
  invalid_profile: {
    title: (maker) => `${maker}의 프로필을 무효로 끝낼까`,
    description:
      'LinkedIn 프로필이 맞지 않아 이 메이커는 영구히 끝난다. 더는 단계가 올라오지 않고, 되돌리는 화면이 없다.',
    confirm: '프로필 무효로 끝내기',
  },
  skipped: {
    title: (maker) => `${maker}을(를) 제외할까`,
    description:
      '이 단계만 넘기는 것이 아니다. 이 메이커는 건너뜀 상태로 영구히 끝나고, 더는 단계가 올라오지 않는다. 되돌리는 화면이 없다.',
    confirm: '메이커 제외',
  },
  closed: {
    title: (maker) => `${maker}을(를) 종료로 기록할까`,
    description: '제안까지 마친 메이커를 끝낸 것으로 기록한다. 이 메이커는 영구히 끝나고, 되돌리는 화면이 없다.',
    confirm: '종료로 기록',
  },
}

/** What the end is called in a button and in a reason line. */
export const ENDING_REASON: Record<Exclude<EndingKind, 'skipped' | 'closed'>, string> = {
  do_not_contact: 'Marked do not contact by operator',
  invalid_profile: 'LinkedIn profile is invalid',
}

export function TerminalConfirm({
  kind,
  maker,
  onCancel,
  onConfirm,
}: {
  /** The ending being asked about; null = closed. */
  kind: EndingKind | null
  maker: string
  onCancel: () => void
  onConfirm: (kind: EndingKind) => void | Promise<void>
}) {
  const copy = COPY[kind ?? 'do_not_contact']
  return (
    <ConfirmDialog
      open={kind !== null}
      onOpenChange={(open) => !open && onCancel()}
      title={copy.title(maker)}
      description={copy.description}
      confirmLabel={copy.confirm}
      confirmVariant="destructive"
      onConfirm={() => (kind ? onConfirm(kind) : undefined)}
    />
  )
}
